export default __webpack_public_path__ + "static/earth_systems-0b619fe032fa9e33aba4a8b86ccee1e0.jpg";